import { useState } from "react";
export const useMatchDetailState = () => {
  const [match, setMatch] = useState(null);
  const [team1Players, setTeam1Players] = useState([]);
  const [team2Players, setTeam2Players] = useState([]);
  const [loading, setLoading] = useState(true);
  const [playersLoading, setPlayersLoading] = useState(true);
  const [error, setError] = useState(null);
  const [apiLoading, setApiLoading] = useState(true);
  const [scorecardData, setScorecardData] = useState(null);

  return {
    match,
    setMatch,
    team1Players,
    setTeam1Players,
    team2Players,
    setTeam2Players,
    loading,
    setLoading,
    playersLoading,
    setPlayersLoading,
    error,
    setError,
    apiLoading,
    setApiLoading,
    scorecardData,
    setScorecardData,
  };
};
